import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useSupportButtonStyles = makeStyles(
  (theme: Theme) => {
    const isDark = theme.palette.mode === 'dark';

    return {
      floatingButton: {
        position: 'fixed',
        bottom: 'var(--xlrt-support-button-bottom, 2rem)',
        right: '2rem',
        zIndex: 1000,
      },

      actionButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        // collapsed state (icon-only)
        width: 48,
        height: 48,
        minWidth: 48,
        minHeight: 48,
        boxSizing: 'border-box',
        padding: 0,

        borderRadius: '1000px',
        backgroundColor: isDark
          ? 'var(--xlrt-color-future-green500)'
          : 'var(--xlrt-color-future-green800)',
        boxShadow:
          '0 1.2px 3.6px rgba(0,0,0,0.10), 0 6.4px 14.4px rgba(0,0,0,0.13)',

        fontSize: '0.875rem',
        color: isDark
          ? 'var(--xlrt-color-ui-gray25)'
          : 'var(--xlrt-color-ui-white)',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '1.125rem',
        letterSpacing: '-0.168px',
        border: 'none',
        textTransform: 'none',

        transition: 'width 200ms ease, padding 200ms ease',

        // expanded state (icon-only)
        '&:hover': {
          width: 'fit-content',
          padding: '0.75rem 1rem',
          gap: '0.625rem',
          backgroundColor: isDark
            ? 'var(--xlrt-color-future-green500)'
            : 'var(--xlrt-color-future-green800)',
          border: 'none',
        },

        '&:hover $label': {
          display: 'block',
        },

        '&:focus-visible': {
          width: 'fit-content',
          padding: '0.75rem 1rem',
          gap: '0.625rem',
          backgroundColor: isDark
            ? 'var(--xlrt-color-future-green500)'
            : 'var(--xlrt-color-future-green800)',
          border: 'none',
        },

        '&:focus-visible $label': {
          display: 'block',
        },

        '&.listOpen': {
          display: 'flex',
          width: 'fit-content',
          padding: '0.75rem 1rem',
          gap: '0.625rem',
          backgroundColor: isDark
            ? 'var(--xlrt-color-future-green500)'
            : 'var(--xlrt-color-future-green800)',
          border: 'none',
        },

        '&.listOpen $label': {
          display: 'block',
        },
      },

      icon: {
        flexShrink: 0,
        fontSize: 18,
      },

      label: {
        display: 'none',
        transition: 'display 150ms ease',
      },
    };
  },
  { name: 'SupportButton' },
);
